<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15_4728)">
      <path
        d="M5.41191 19.4117H1.17661C0.882497 19.4117 0.588379 19.1176 0.588379 18.8235V14.5294C0.588379 14.1765 0.882497 13.9412 1.17661 13.9412H5.29426V18.8235C5.29426 19 5.35308 19.2353 5.41191 19.4117Z"
        fill="#7E8793"
      />
      <path
        d="M13.5295 11.7647V18.8235C13.5295 19.1176 13.2354 19.4117 12.9413 19.4117H7.05894C6.76482 19.4117 6.4707 19.1176 6.4707 18.8235V11.7647C6.4707 11.4117 6.76482 11.1765 7.05894 11.1765H12.9413C13.2354 11.1765 13.5295 11.4117 13.5295 11.7647Z"
        fill="#7E8793"
      />
      <path
        d="M19.4119 15.2941V18.8235C19.4119 19.1176 19.1178 19.4117 18.8237 19.4117H14.5884C14.6472 19.2353 14.706 19 14.706 18.8235V14.7058H18.8237C19.1178 14.7058 19.4119 14.9411 19.4119 15.2941Z"
        fill="#7E8793"
      />
      <path
        d="M14.7649 4.70584L12.8237 6.58819L13.2943 9.29408C13.3531 9.52937 13.2355 9.76466 13.059 9.88231C12.8825 9.99996 12.5884 9.99996 12.4119 9.94113L10.0002 8.64702L7.58839 9.88231C7.41192 9.99996 7.17663 9.99996 7.00016 9.82349C6.82369 9.70584 6.70604 9.47054 6.76486 9.23525L7.23545 6.52937L5.23545 4.70584C5.1178 4.58819 5.05898 4.3529 5.1178 4.1176C5.17663 3.88231 5.3531 3.76466 5.58839 3.70584L8.29427 3.29407L9.47075 0.88231C9.64722 0.470545 10.3531 0.470545 10.5296 0.88231L11.706 3.29407L14.4119 3.70584C14.6472 3.76466 14.8237 3.88231 14.8825 4.1176C14.9413 4.3529 14.8825 4.58819 14.7649 4.70584Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_4728">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_491_535)">
      <path
        d="M5.41191 19.4117H1.17661C0.882497 19.4117 0.588379 19.1176 0.588379 18.8235V14.5294C0.588379 14.1765 0.882497 13.9412 1.17661 13.9412H5.29426V18.8235C5.29426 19 5.35308 19.2353 5.41191 19.4117Z"
        fill="#B4BEC1"
      />
      <path
        d="M13.5295 11.7646V18.8235C13.5295 19.1176 13.2354 19.4117 12.9413 19.4117H7.05894C6.76482 19.4117 6.4707 19.1176 6.4707 18.8235V11.7646C6.4707 11.4117 6.76482 11.1764 7.05894 11.1764H12.9413C13.2354 11.1764 13.5295 11.4117 13.5295 11.7646Z"
        fill="#B4BEC1"
      />
      <path
        d="M19.4119 15.294V18.8235C19.4119 19.1176 19.1178 19.4117 18.8237 19.4117H14.5884C14.6472 19.2352 14.706 18.9999 14.706 18.8235V14.7058H18.8237C19.1178 14.7058 19.4119 14.9411 19.4119 15.294Z"
        fill="#B4BEC1"
      />
      <path
        d="M14.7649 4.70584L12.8237 6.58819L13.2943 9.29408C13.3531 9.52937 13.2355 9.76466 13.059 9.88231C12.8825 9.99996 12.5884 9.99996 12.4119 9.94113L10.0002 8.64702L7.58839 9.88231C7.41192 9.99996 7.17663 9.99996 7.00016 9.82349C6.82369 9.70584 6.70604 9.47054 6.76486 9.23525L7.23545 6.52937L5.23545 4.70584C5.1178 4.58819 5.05898 4.3529 5.1178 4.1176C5.17663 3.88231 5.3531 3.76466 5.58839 3.70584L8.29427 3.29407L9.47075 0.88231C9.64722 0.470545 10.3531 0.470545 10.5296 0.88231L11.706 3.29407L14.4119 3.70584C14.6472 3.76466 14.8237 3.88231 14.8825 4.1176C14.9413 4.3529 14.8825 4.58819 14.7649 4.70584Z"
        fill="#00FF5E"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_535">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1811 17.7204H19.4141C19.7377 17.7204 20 17.9827 20 18.3063C20 18.6299 19.7377 18.8922 19.4141 18.8922H0.585938C0.262344 18.8922 0 18.6299 0 18.3063C0 17.9827 0.262344 17.7204 0.585938 17.7204H0.818906V10.8426C0.818906 10.519 1.08125 10.2567 1.40484 10.2567H5.90246V1.69531C5.90246 1.37172 6.1648 1.10938 6.4884 1.10938H13.5116C13.8352 1.10938 14.0975 1.37172 14.0975 1.69531V7.11105H18.5952C18.9188 7.11105 19.1811 7.3734 19.1811 7.69699V17.7204ZM1.99078 17.7204H5.90246V11.4286H1.99078V17.7204ZM7.07434 17.7204H12.9257V2.28125H7.07434V17.7204ZM14.0975 17.7204H18.0092V8.28293H14.0975V17.7204ZM10.7569 10.8873H10.9703C11.2939 10.8873 11.5562 11.1496 11.5562 11.4732C11.5562 11.7968 11.2939 12.0592 10.9703 12.0592H9.37222C9.04863 12.0592 8.78629 11.7968 8.78629 11.4732C8.78629 11.1496 9.04863 10.8873 9.37222 10.8873H9.585V9.41609L9.43789 9.51944C9.17312 9.70558 8.80769 9.64171 8.6216 9.37691C8.43554 9.11218 8.49933 8.74671 8.7641 8.56066L9.3248 8.16663C9.60351 7.97081 9.96441 7.94663 10.2668 8.1037C10.5691 8.26073 10.7569 8.56991 10.7569 8.91058V10.8873Z"
      fill="#9C9C9C"
    />
  </svg>
</template>
<script lang="ts">
export default {};
</script>
